import React, { FC } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import { TabType } from '../../PhotoPickerDialog.types';

type TabNavigationProps = Readonly<{
  selectedTab: TabType;
  onSelectTab: (tab: TabType) => void;
  isCropTabDisabled: boolean;
  enableMobileCrop?: boolean;
  isMobileCropTabDisabled?: boolean;
}>;

type ChipProps = Readonly<{
  label: string;
  onClick: () => void;
  isSelected: boolean;
  isDisabled?: boolean;
}>;

const Chip: FC<ChipProps> = props => {
  const { label, onClick, isSelected, isDisabled } = props;

  return (
    <Flex
      as="button"
      aria-label={label}
      paddingX={7}
      paddingY={3}
      justifyContent="center"
      alignItems="center"
      borderRadius={pxToRem(200)}
      backgroundColor={isSelected ? 'mono2' : 'transparent'}
      onClick={onClick}
      disabled={isDisabled}
      _disabled={{
        cursor: 'not-allowed',
        opacity: 0.7,
      }}
    >
      <TextV2
        typographyVariant="body3"
        color="mono14"
      >
        {label}
      </TextV2>
    </Flex>
  );
};

export const TabNavigation: FC<TabNavigationProps> = props => {
  const { selectedTab, onSelectTab, isCropTabDisabled, enableMobileCrop = false, isMobileCropTabDisabled = false } = props;
  const { tq } = useTranslation('photoPickerDialog');

  return (
    <Flex
      width="100%"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
    >
      <Chip
        label={tq`Select`}
        isSelected={selectedTab === TabType.SELECT_PHOTO}
        onClick={() => onSelectTab(TabType.SELECT_PHOTO)}
      />
      <Chip
        label={enableMobileCrop ? tq`Desktop` : tq`Crop`}
        isSelected={selectedTab === TabType.CROP}
        onClick={() => onSelectTab(TabType.CROP)}
        isDisabled={isCropTabDisabled}
      />
      {enableMobileCrop && (
        <Chip
          label={tq`Mobile`}
          isSelected={selectedTab === TabType.MOBILE_CROP}
          onClick={() => onSelectTab(TabType.MOBILE_CROP)}
          isDisabled={isMobileCropTabDisabled}
        />
      )}
    </Flex>
  );
};
